import { IActionBase, ISummaryState } from "../models/root.interface";
import { ADD_OTP_GENERATED, ADD_OTP_DELIVERED, ADD_OTP_VERIFIED } from "../actions/summary.action";

const initialState: ISummaryState = {
   OTPGenerated:0,OTPDelivered:0,OTPVerified:0
};
function summaryReducer(state: ISummaryState = initialState, action: IActionBase): ISummaryState {
    switch (action.type) {
        case ADD_OTP_GENERATED: {
            return {...state, OTPGenerated:action.OTPGenerated};
        }
        case ADD_OTP_DELIVERED: {
            return {...state, OTPDelivered:action.OTPDelivered};
        }
        case ADD_OTP_VERIFIED: {
            return {...state, OTPVerified:action.OTPVerified};
        }
        default:
            return state;
    }
}


export default summaryReducer;